export default {
  badge: 'Abzeichen',
  open: 'Öffnen',
  close: 'Schließen',
  dismiss: 'Verwerfen',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Abbrechen',
  },
  dataIterator: {
    noResultsText: 'Keine Elemente gefunden',
    loadingText: 'Lade Elemente...',
  },
  dataTable: {
    itemsPerPageText: 'Zeilen pro Seite:',
    ariaLabel: {
      sortDescending: 'Absteigend sortiert.',
      sortAscending: 'Aufsteigend sortiert.',
      sortNone: 'Nicht sortiert.',
      activateNone: 'Aktivieren um Sortierung zu entfernen.',
      activateDescending: 'Aktivieren um absteigend zu sortieren.',
      activateAscending: 'Aktivieren um aufsteigend zu sortieren.',
    },
    sortBy: 'Sortiere nach',
  },
  dataFooter: {
    itemsPerPageText: 'Elemente pro Seite:',
    itemsPerPageAll: 'Alle',
    nextPage: 'Nächste Seite',
    prevPage: 'Vorherige Seite',
    firstPage: 'Erste Seite',
    lastPage: 'Letzte Seite',
    pageText: '{0}-{1} von {2}',
  },
  dateRangeInput: {
    divider: 'bis',
  },
  datePicker: {
    itemsSelected: '{0} ausgewählt',
    range: {
      title: 'Daten auswählen',
      header: 'Daten eingeben',
    },
    title: 'Datum auswählen',
    header: 'Datum eingeben',
    input: {
      placeholder: 'Datum eingeben',
    },
    ariaLabel: {
      previousMonth: 'Vorheriger Monat',
      nextMonth: 'Nächster Monat',
      selectYear: 'Jahr auswählen',
      selectDate: '{0}',
      currentDate: 'Heute, {0}',
    },
  },
  noDataText: 'Keine Daten vorhanden',
  carousel: {
    prev: 'Vorheriges Bild',
    next: 'Nächstes Bild',
    ariaLabel: {
      delimiter: 'Element {0} von {1}',
    },
  },
  calendar: {
    moreEvents: '{0} mehr',
    today: 'Heute',
  },
  input: {
    clear: '{0} leeren',
    prependAction: '{0} vorangestellte Aktion',
    appendAction: '{0} angehängte Aktion',
    otp: 'Bitte OTP-Zeichen {0} eingeben',
  },
  fileInput: {
    counter: '{0} Dateien',
    counterSize: '{0} Dateien ({1} gesamt)',
  },
  fileUpload: {
    title: 'Datei hier ablegen',
    divider: 'oder',
    browse: 'Dateien durchsuchen',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Uhrzeit auswählen',
  },
  pagination: {
    ariaLabel: {
      root: 'Seitennavigation',
      next: 'Nächste Seite',
      previous: 'Vorherige Seite',
      page: 'Gehe zu Seite {0}',
      currentPage: 'Aktuelle Seite, Seite {0}',
      first: 'Erste Seite',
      last: 'Letzte Seite',
    },
  },
  stepper: {
    next: 'Weiter',
    prev: 'Zurück',
  },
  rating: {
    ariaLabel: {
      item: 'Bewertung {0} von {1}',
    },
  },
  loading: 'Laden...',
  infiniteScroll: {
    loadMore: 'Mehr laden',
    empty: 'Nichts weiteres',
  },
  rules: {
    required: 'Dieses Feld ist erforderlich',
    email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    number: 'Dieses Feld darf nur Zahlen enthalten',
    integer: 'Dieses Feld darf nur Ganzzahlen enthalten',
    capital: 'Dieses Feld darf nur Großbuchstaben enthalten',
    maxLength: 'Sie dürfen maximal {0} Zeichen eingeben',
    minLength: 'Sie müssen mindestens {0} Zeichen eingeben',
    strictLength: 'Die Länge des eingegebenen Feldes ist ungültig',
    exclude: 'Das Zeichen {0} ist nicht erlaubt',
    notEmpty: 'Bitte wählen Sie mindestens einen Wert aus',
    pattern: 'Ungültiges Format',
  },
  hotkey: {
    then: 'dann',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Eingabe',
    escape: 'Escape',
    upArrow: 'Pfeil nach oben',
    downArrow: 'Pfeil nach unten',
    leftArrow: 'Pfeil nach links',
    rightArrow: 'Pfeil nach rechts',
    backspace: 'Rücktaste',
    space: 'Leertaste',
    plus: 'plus',
    shortcut: 'Tastenkürzel: {0}',
  },
  video: {
    play: 'Abspielen',
    pause: 'Pause',
    seek: 'Suchen',
    volume: 'Lautstärke',
    showVolume: 'Lautstärkeregler anzeigen',
    mute: 'Stummschalten',
    unmute: 'Stummschaltung aufheben',
    enterFullscreen: 'Vollbild',
    exitFullscreen: 'Vollbild beenden',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Farbe vom Bildschirm auswählen',
      hueSlider: 'Farbton',
      alphaSlider: 'Transparenz',
      redInput: 'Rot',
      greenInput: 'Grün',
      blueInput: 'Blau',
      alphaInput: 'Transparenz',
      hueInput: 'Farbton',
      saturationInput: 'Sättigung',
      lightnessInput: 'Helligkeit',
      hexInput: 'HEX-Wert',
      hexaInput: 'HEX-Wert mit Transparenz',
      changeFormat: 'Farbformat ändern',
    },
  },
}
